// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2Agjv","signatureButtonsRight":"ModalSign_signatureButtonsRight__onPOK"};